import { ServiceAccount, BillingAddress, PaymentInfo } from "../../models/service-account";
import {
  axiosInstance as Repository,
} from "../repository";

// const  serviceAccountModel = require("../../models/service-account");

const RESOURCE = "/organizations";

function getInstance(item) {
  const obj = new ServiceAccount();
  obj.serviceAccountId = item.organization_id;
  obj.serviceAccountName = item.name;
  obj.contractUserId = item.owner_user_id;
  obj.contractUserEmail = item.owner_user_email;
  obj.contractUserName = item.owner_user_name;

  const billingAddress = new BillingAddress();
  if (item.billing_address) {
    billingAddress.companyName = item.billing_address.company_name;
    billingAddress.personInChargeName = item.billing_address.person_in_charge_name;
    billingAddress.postalCode = item.billing_address.postal_code;
    billingAddress.state = item.billing_address.state;
    billingAddress.town = item.billing_address.town;
    billingAddress.street = item.billing_address.street;
    billingAddress.building = item.billing_address.building;
    billingAddress.phoneNumber = item.billing_address.phone_number;
  }
  obj.billingAddress = billingAddress;

  const paymentInfo = new PaymentInfo();
  if (item.payment_info) {
    paymentInfo.paymentMethod = item.payment_info.payment_method;
  }
  obj.paymentInfo = paymentInfo;

  return obj;
}

function makeRequestJson(serviceAccount) {
  let requestJosn = {};

  requestJosn = {
    organization_id: serviceAccount.serviceAccountId,
    name: serviceAccount.serviceAccountName,
    owner_user_id: serviceAccount.contractUserId,
    owner_user_email: serviceAccount.contractUserEmail,
    owner_user_name: serviceAccount.contractUserName,
  };

  if (serviceAccount.billingAddress) {
    requestJosn.billing_address = {};
    requestJosn.billing_address.company_name = serviceAccount.billingAddress.companyName;
    requestJosn.billing_address.person_in_charge_name
      = serviceAccount.billingAddress.personInChargeName;
    requestJosn.billing_address.postal_code = serviceAccount.billingAddress.postalCode;
    requestJosn.billing_address.state = serviceAccount.billingAddress.state;
    requestJosn.billing_address.town = serviceAccount.billingAddress.town;
    requestJosn.billing_address.street = serviceAccount.billingAddress.street;
    requestJosn.billing_address.building = serviceAccount.billingAddress.building;
    requestJosn.billing_address.phone_number = serviceAccount.billingAddress.phoneNumber;
  }

  if (serviceAccount.paymentInfo) {
    requestJosn.payment_info = {};
    requestJosn.payment_info.payment_method = serviceAccount.paymentInfo.paymentMethod;
  }

  return requestJosn;
}

export default {

  async index() {
    const response = await Repository.get(`${RESOURCE}`);
    const res = [];
    response.data.items.forEach((item) => {
      res.push(getInstance(item));
    });
    return res;
  },
  async get(serviceAccountId) {
    const response = await Repository.get(`${RESOURCE}/${serviceAccountId}`);
    return getInstance(response.data.item);
  },
  async update(serviceAccount) {
    const requestParams = makeRequestJson(serviceAccount);
    await Repository.put(`${RESOURCE}/${serviceAccount.serviceAccountId}`, requestParams);
  },

};
